import * as React from "react";
import type { SVGProps } from "react";
const SvgLiftCabinBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lift-cabin-big_svg__a)">
      <path d="M18.71 22H5.29c-1.27 0-2.36-.89-2.66-2.16l-.21-.88c-.62-2.61-.56-5.34.17-7.92C2.93 9.84 4.02 9 5.23 9h13.52c1.21 0 2.3.84 2.64 2.04.73 2.58.79 5.31.17 7.92l-.21.88c-.3 1.27-1.4 2.16-2.66 2.16zM5.24 11c-.33 0-.62.24-.72.59-.64 2.25-.69 4.64-.15 6.91l.21.88c.09.36.38.62.72.62h13.41c.33 0 .63-.26.72-.62l.21-.88c.54-2.27.49-4.66-.15-6.91-.1-.35-.39-.59-.72-.59z" />
      <path d="M12 10.58c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.58c0 .55-.45 1-1 1M20.53 16.5H3.47c-.55 0-1-.45-1-1s.45-1 1-1h17.06c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7M13.02 22h-2.05c-1.81 0-3.29-1.48-3.29-3.29v-6.42C7.68 10.48 9.16 9 10.97 9h2.05c1.81 0 3.29 1.48 3.29 3.29v6.42c0 1.81-1.48 3.29-3.29 3.29m-2.05-11c-.71 0-1.29.58-1.29 1.29v6.42c0 .71.58 1.29 1.29 1.29h2.05c.71 0 1.29-.58 1.29-1.29v-6.42c0-.71-.58-1.29-1.29-1.29z" />
    </g>
    <defs>
      <clipPath id="lift-cabin-big_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLiftCabinBig;
